import {createReducer, on} from '@ngrx/store';
import * as DeleteOrganizationActions from '../actions/delete-organization.actions';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const deleteOrganizationFeatureKey = 'deleteOrganization';

export interface State {
  record: Organization | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const reducer = createReducer(
  initialState,

  on(DeleteOrganizationActions.deleteOrganization, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true
  })),
  on(DeleteOrganizationActions.deleteOrganizationSuccess, (_state: State, action: { data: Organization }): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(DeleteOrganizationActions.deleteOrganizationFailure, (_state: State, action: { error: unknown }): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(DeleteOrganizationActions.clearDeleteOrganizationState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);
